var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-wrap dark:border dark:border-light-charcoal"},[_c('div',{ref:"mapContainer",staticClass:"map"},[(!_vm.mapLoaded)?_c('div',{staticClass:"p-4 justify-self-center w-16 m-auto mt-60"},[_c('img',{staticClass:"dark:invert-75",attrs:{"src":"/images/loading-gif.webp"}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }